import { Connection, useIntegrationApp } from '@integration-app/react';
import { ArrowClockwise, Pencil, Wrench } from '@phosphor-icons/react';
import { SideDropActions } from 'src/components/SideDropActions';
import { useNotification } from 'src/contexts/NotificationContext';
import useAuthedRequest from 'src/hooks/useAuthedRequest';

const IntegrationAppActions = ({
  id,
  integrationId,
  integration,
}: Connection) => {
  const { post } = useAuthedRequest();
  const integrationApp = useIntegrationApp();

  const notification = useNotification();

  const options = [
    {
      label: 'Edit',
      Icon: Pencil,
      onClick: () => integrationApp?.integration(integrationId).open(),
    },
    {
      label: 'Run Sync',
      Icon: ArrowClockwise,
      onClick: async () => {
        const flows = await integrationApp.flows.find({
          integrationId,
        });
        const batchFlow = flows?.items.find(
          ({ key }) => key === 'create-batch-call',
        );
        if (batchFlow) {
          await integrationApp.connection(id).flow(batchFlow.id).run({
            input: null,
          });
          return notification.success('Sync run successfully');
        }
        return notification.error('No sync flow found');
      },
    },
  ];

  return (
    <div className="flex justify-center items-center">
      <SideDropActions options={options} />
    </div>
  );
};

export default IntegrationAppActions;
